import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Container.module.css';

export type ContainerMaxWidth = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  maxWidth?: ContainerMaxWidth;
  children?: ReactNode;
};

export function Container({ maxWidth = 'lg', className, children, ...rest }: ContainerProps) {
  return (
    <div className={cn(styles.root, styles[`max_${maxWidth}`], className)} {...rest}>
      {children}
    </div>
  );
}
